import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d902621"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "company-popup" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "title-wrapper" }
const _hoisted_4 = { class: "title-text" }
const _hoisted_5 = { class: "sub-title" }
const _hoisted_6 = { class: "block-btns" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "base-info" }
const _hoisted_9 = { class: "detail" }
const _hoisted_10 = { class: "detail-item" }
const _hoisted_11 = { class: "detail-item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 设备： ")
const _hoisted_13 = { class: "detail-item" }
const _hoisted_14 = { class: "detail-item" }
const _hoisted_15 = { class: "chart-title" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-chart-unit" }, "mg/m³", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "company-chart" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Option = _resolveComponent("Option")!
  const _component_Select = _resolveComponent("Select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.popupData.name ?? "-"), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.popupData.companyAddress ??  "-"), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(['btn',_ctx.curBlock === 'baseInfo'?'active':'']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeBlock('baseInfo')))
          }, "基本信息", 2),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(['btn',_ctx.curBlock === 'cameraInfo'?'active':'']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeBlock('cameraInfo')))
          }, "视频监控", 2), [
            [_vShow, _ctx.popupData.cameraFlag]
          ])
        ]),
        _createElementVNode("div", {
          class: "iconfont icon-close close",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeRankingVisable && _ctx.changeRankingVisable(...args)))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _withDirectives(_createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, " 负责人：" + _toDisplayString(_ctx.popupData.leadCadre ?? "-"), 1),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Select, {
              ref: "select",
              value: _ctx.defaultValue,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.defaultValue) = $event)),
              style: {"width":"120px","height":"34px"},
              onChange: _ctx.handleChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mnNos, (item, key) => {
                  return (_openBlock(), _createBlock(_component_Option, {
                    key: key,
                    value: item.chimneyNo
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.chimneyNo), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_13, " 联系电话：" + _toDisplayString(_ctx.popupData.phone ??'-'), 1),
          _createElementVNode("div", _hoisted_14, " 监测时间：" + _toDisplayString(_ctx.monTime ? _ctx.moment(_ctx.monTime, "YYYYMMDDHHmm").format("YY-MM-DD HH:mm:ss") : "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indexLists, (val, key) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: key,
              class: _normalizeClass(['item', _ctx.checked === key ? 'active-bg' : '']),
              onClick: ($event: any) => (_ctx.handleHistoryChange(key))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(['iconfont', val.icon, _ctx.checked === key ? 'active' : ''])
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(val.lable), 1)
              ]),
              _createElementVNode("div", null, _toDisplayString(Number(_ctx.indexAverage[key]).toFixed(2)), 1)
            ], 10, _hoisted_16)), [
              [_vShow, _ctx.indexAverage[key]]
            ])
          }), 128))
        ]),
        _hoisted_17,
        _hoisted_18
      ], 512), [
        [_vShow, _ctx.curBlock === 'baseInfo']
      ]),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.cameraType), {
        class: "camera-info",
        ref: "cameraRef",
        popupData: _ctx.popupData
      }, null, 8, ["popupData"]))
    ])
  ]))
}